import React from 'react';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { Pipeline } from './visuals';
const DELIVERY = [{
  title: 'Master campaign development',
  description: 'Global concept and reusable campaign assets'
}, {
  title: 'Teasers and trailers',
  description: 'Campaign content units for different needs and formats'
}, {
  title: 'Localization',
  description: 'Translation, regulatory updates, market adaptation per country'
}, {
  title: 'Country activation',
  description: 'Launch, channel setup, execution, and in-market support'
}, {
  title: 'Associated activities',
  description: 'Hosting, data, insights, and performance recommendations'
}];
const COSTS = [{
  value: '~€3k',
  title: 'Master creation',
  description: 'Flat fee · complexity range €3.5k–€30k'
}, {
  value: '€1,000',
  title: 'Localization, activation + insights',
  description: 'Per country · once-off per campaign, bundled'
}, {
  value: '3 months',
  title: 'Minimum duration',
  description: 'Per campaign engagement'
}];
export function DeliveryModel() {
  return <SlideFrame data-id="element-107" data-mp="38r1637yd9s4c">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-108" data-mp="3ni0byb7ti2k8">
        <SlideHeader eyebrow="07 — Delivery & cost" title="Snak campaign delivery model and" accent="cost structure" kicker="Snakker for LEO Pharma" data-id="element-109" data-mp="3nh8hx4tvccw2" />

        <div className="mt-[3.2vh] grid min-h-0 flex-1 grid-cols-[1.15fr_1fr] gap-[1.4vw]" data-id="element-110" data-mp="2utl2033jmafr">
          <Reveal delay={0.2} className="flex min-h-0" data-id="element-111" data-mp="2pvt0chd3j9yd">
            <div className="flex min-h-0 w-full flex-col rounded-[0.8vw] border border-white/10 bg-white/[0.035] p-[1.35vw]" data-id="element-112" data-mp="34s1vp7tv935i">
              <h3 className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.18em] text-white/70`} data-id="element-113" data-mp="2zrmjijlbm1p4">
                Delivery model
              </h3>
              <div className="mt-[2vh] flex min-h-0 flex-1" data-id="element-114" data-mp="f15a8z2rao7q">
                <Pipeline steps={DELIVERY} data-id="element-115" data-mp="m5etanh1il97" />
              </div>
            </div>
          </Reveal>

          <div className="flex min-h-0 flex-col gap-[1.2vh]" data-id="element-116" data-mp="r4hntdze992x">
            <Reveal delay={0.3} className="shrink-0" data-id="element-117" data-mp="r2n23xgatcxs">
              <h3 className={`${t.label} font-semibold uppercase tracking-[0.18em] text-white/70`} data-id="element-118" data-mp="w31efroxn91m">
                Cost structure
              </h3>
            </Reveal>
            {COSTS.map((item, index) => <Reveal key={item.title} delay={0.36 + index * 0.07} className="flex min-h-0 flex-1" data-id="element-119" data-mp="3gqduh1bt84t" data-mpi={index}>
                <div className="flex w-full items-center justify-between gap-[1vw] rounded-[0.6vw] border border-white/10 bg-white/[0.035] px-[1.3vw]" data-id="element-120" data-mp="dctax8hbmgkw">
                  <div className="min-w-0" data-id="element-121" data-mp="i5mis5836517">
                    <p className={`${t.small} font-semibold leading-[1.2] text-white`} data-id="element-122" data-mp="3gulb3a5m26u6">
                      {item.title}
                    </p>
                    <p className={`${t.label} mt-[0.5vh] leading-[1.3] text-white/55`} data-id="element-123" data-mp="22ya5p5eehu0v">
                      {item.description}
                    </p>
                  </div>
                  <p className="shrink-0 text-[clamp(18px,2.7vw,52px)] font-semibold tracking-[-0.03em] text-[#A26BFF]" data-id="element-124" data-mp="1tw0vyhqyi4oj">
                    {item.value}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>

        <Reveal delay={0.68} className="mt-[2.8vh] flex shrink-0 items-baseline gap-[2vw] border-t border-white/10 pt-[2.4vh]" data-id="element-125" data-mp="1f8fwqyx7cplw">
          <span className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.22em] text-[#A26BFF]`} data-id="element-126" data-mp="1b6ucgsic991o">
            Core principle
          </span>
          <p className={`${t.small} leading-[1.35] text-white/75`} data-id="element-127" data-mp="117d94hqk778v">
            A full-service turnkey model, not a disaggregated menu — strategy, creation,
            localization, activation, and insight work as one.
          </p>
        </Reveal>
      </div>
    </SlideFrame>;
}